module.exports = __webpack_public_path__ + "img/icontitle_4.0f8507ed.png";